export default "__VITE_ASSET__C12$pYm0__"